export default "__VITE_ASSET__F0Kj_gcs__"